// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-date-picker-years {
  height: 288px;
  overflow-y: scroll;
}

:where(.vuetify-styles) .v-date-picker-years__content {
  display: grid;
  flex: 1 1;
  justify-content: space-around;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 24px;
  padding-inline: 32px;
}
:where(.vuetify-styles) .v-date-picker-years__content .v-btn {
  padding-inline: 8px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDatePicker/VDatePickerYears.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".v-date-picker-years {\n  height: 288px;\n  overflow-y: scroll;\n}\n\n.v-date-picker-years__content {\n  display: grid;\n  flex: 1 1;\n  justify-content: space-around;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px 24px;\n  padding-inline: 32px;\n}\n.v-date-picker-years__content .v-btn {\n  padding-inline: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
